
import Icon from "../../../../public/assets/images/keinternational/true.png"
import { FaPlus } from "react-icons/fa6";
import { FiMinus } from "react-icons/fi";
import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';


const Slides = [
  {
    id: "1",
    image: "assets/images/keindia/slide1.png",
  },
  {
    id: "2",
    image: "assets/images/keindia/slide2.png",
  },
  {
    id: "3",
    image: "assets/images/keindia/slide3.png",
  },
  {
    id: "4",
    image: "assets/images/keindia/slide4.png",
  },
  {
    id: "5",
    image: "assets/images/keindia/slide5.png",
  },
  {
    id: "6",
    image: "assets/images/keindia/slide6.png",
  },
  {
    id: "7",
    image: "assets/images/keindia/slide7.png",
  },

];


const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });




export const SectionSeven = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });


  const fullImageSliderSettings = {
    autoplay: true,
    autoplaySpeed: 5000, // 5 seconds
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };


  return (
    <div className="section-seven-Ind">
      <div className="container-fluid">
        <div className="heading-Ind" style={{ textAlign: 'center' }}>
          <h1 className="suite-title-Ind" style={{ color: "black", fontWeight: "400" }}>
            Engage Shoppers Across Channels <br />
            with <span style={{ color: "#2400FF" }}>Personalized Journeys</span>  that Convert
          </h1>
        </div>


        <div className="d-flex justify-content-center">
          {isMobile ? (
            // ✅ MOBILE VIEW — only slider
            <div style={{ width: '100%', maxWidth: '100%', padding: '0 5px', display: 'flex', justifyContent: "center" }}>
              <Slider {...fullImageSliderSettings}>
                <div>
                  <img src="assets/images/keindia/slide1.png" alt="Banner1" className="slide-ban-image " />
                </div>
                <div>
                  <img src="assets/images/keindia/slide2.png" alt="Banner2" className="slide-ban-image " />
                </div>
                <div>
                  <img src="assets/images/keindia/slide3.png" alt="Banner3" className="slide-ban-image " />
                </div>
                <div>
                  <img src="assets/images/keindia/slide4.png" alt="Banner4" className="slide-ban-image " />
                </div>
                <div>
                  <img src="assets/images/keindia/slide5.png" alt="Banner5" className="slide-ban-image " />
                </div>
                <div>
                  <img src="assets/images/keindia/slide6.png" alt="Banner6" className="slide-ban-image " />
                </div>
                <div>
                  <img src="assets/images/keindia/slide7.png" alt="Banner7" className="slide-ban-image " />
                </div>


              </Slider>
            </div>
          ) : (
            // ✅ DESKTOP VIEW — animated image banners
            <Swiper
              effect={'coverflow'}
              grabCursor={true}
              centeredSlides={true}
              slidesPerView={'auto'}
              loop={true}
              coverflowEffect={{
                rotate: 0,
                stretch: 0,
                depth: 100,
                modifier: 2.5,
                slideShadows: false,
              }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
                dynamicBullets: true
              }}
              // navigation={true}
              modules={[EffectCoverflow, Pagination, Navigation, Autoplay]}
              className="mySwiper"
            >
              {Slides.map((section) => (
                <SwiperSlide key={section.id}>
                  <div className="slide-wrapper">
                    <img
                      className="slide-image"
                      src={section.image}
                      alt={`slide_image_${section.id}`}
                      style={{
                        width: '100%',
                        height: 'auto',
                        maxHeight: '500px',
                        objectFit: 'contain'
                      }}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>

        <div className="quote1">
          <img src="assets/images/keindia/quote.png" alt="" />
          <h4 className="quotes1">KwikEngage along with KwikPass enabled us to scale retention marketing <br /> revenue to upwards of 1 Cr monthly at a profitable ROI for the brand. <br />The data network of GoKwik is truly a differentiator.</h4>

          <p className="owner">Jayanth R , D2C Head, Bombay Shaving Company</p>

          <img style={{ marginTop: "15px" }} src="assets/images/keindia/bscblack.png" alt="" />
        </div>
      </div>


    </div>



  )
};
